import { cx } from "../../../utils/classnames";
import {
  FilterOption,
  RESERVATION_FILTER_KEYS as KEYS,
  RESERVATION_STATUS_OPTIONS
} from "./reservationFilters";
import useFilterParams from "./useFilterParams";

interface FilterStatusTabsProps {
  // The URL key the status is written to, and the statuses offered; the ticket list's by default.
  paramKey?: string;
  options?: FilterOption[];
}

// Status is the filter reached for most, so it is one click away rather than inside a menu.
const FilterStatusTabs = ({
  paramKey = KEYS.statusId,
  options = RESERVATION_STATUS_OPTIONS
}: FilterStatusTabsProps) => {
  const { get, set } = useFilterParams();
  const statusId = get(paramKey);
  const tabs = [{ label: "Të gjitha", value: "" }, ...options];

  return (
    // Scrolls sideways on narrow screens; never vertically, or Windows shows a stub scrollbar.
    <div role="tablist" aria-label="Statusi" className="flex gap-1 overflow-x-auto overflow-y-hidden">
      {tabs.map((tab) => {
        const selected = statusId === tab.value;
        return (
          <button
            key={tab.label}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => set({ [paramKey]: tab.value })}
            className={cx([
              "shrink-0 whitespace-nowrap border-b-2 px-3 py-2 text-sm duration-200",
              selected
                ? "border-primary font-medium text-primary"
                : "border-transparent text-neutral hover:text-black"
            ])}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default FilterStatusTabs;
